import { Injectable } from '@angular/core';
import { Restangular } from 'ngx-restangular';
import { AuthService } from "./auth.service";
import { ApiCollectionResponse } from "../app/app.interfaces";
import { EventService } from "./event.service";
import { Network } from "@ionic-native/network";

@Injectable()
export class ApiService {
  
  private currentRequest;
  
  public isConnected: boolean = true;

  constructor(private restangular: Restangular,
              private eventService: EventService,
              private network: Network,
              private authService: AuthService) {

    
    this.isConnected = (network.type !== 'none');
    network.onConnect().subscribe(()=> {
      this.isConnected = true;
    });
    network.onDisconnect().subscribe(()=> {
      this.isConnected = false;
    });
    
  }

  

  getCollection(type: string, filters: any = {}): Promise<ApiCollectionResponse> {
    return new Promise((resolve, reject) => {
      
      this.eventService.apiLoading.emit({ loading: true, method: 'getCollection' });
      
      this.authService.afterTokenLoad().then(() => {
        this.currentRequest = this.restangular.all(type).getList(filters).subscribe(
          res => {
            
            let viewData = res.view;
            delete res.view;
            
            let collectionResponse: ApiCollectionResponse = {
              items: res,
              view: viewData
            };
            
            this.eventService.apiLoading.emit({ loading: false });

						resolve(collectionResponse);
          },
          err => {
            this.eventService.apiLoading.emit({ loading: false });
            reject(err);
          });
      });
    });
  }
  
  getSubCollection(type: string, subtype: string, filters: any = {}): Promise<ApiCollectionResponse> {
    return new Promise((resolve, reject) => {
      
      this.eventService.apiLoading.emit({ loading: true, method: 'getCollection' });
      
      this.authService.afterTokenLoad().then(() => {
        this.currentRequest = this.restangular.oneUrl(type).getList(subtype, filters).subscribe(
          res => {
            
            let viewData = res.view;
            delete res.view;
            
            let collectionResponse: ApiCollectionResponse = {
              items: res,
              view: viewData
            };
            
            this.eventService.apiLoading.emit({ loading: false });
            resolve(collectionResponse);
          },
          err => {
            this.eventService.apiLoading.emit({ loading: false });
            reject(err);
          });
      });
    });
  }
  
  getResource(iri: string): Promise<any> {
    return new Promise((resolve, reject) => {
      this.eventService.apiLoading.emit({ loading: true, method: 'getResource' });
      this.authService.afterTokenLoad().then(() => {
        this.currentRequest = this.restangular.one(iri).get().subscribe(
          res => {
            this.eventService.apiLoading.emit({ loading: false });
            resolve(res);
          },
          err => {
            this.eventService.apiLoading.emit({ loading: false });
            reject(err);
          });
      });
    });
    
  }
  
  
  getResourceById(resourceType: string, id: Number): Promise<any> {
    const iri = '/'+resourceType+'/'+id.toString(10);
    return this.getResource(iri);
  }

  createResource(type, resource): any {
    return new Promise((resolve, reject) => {
      this.eventService.apiLoading.emit({ loading: true, method: 'createResource' });
      let postData = ApiService.convertResourceToPostData(resource);
      this.restangular.all('').customPOST(postData, type, {}).subscribe(result => {
        this.eventService.apiLoading.emit({ loading: false });
        resolve(result);
      }, err => {
        this.eventService.apiLoading.emit({ loading: false });
        reject(err);
      });
    });
  }

  updateResource(resource, postData = null): Promise<any> {

    return new Promise((resolve, reject) => {
      
      let resourceUri = resource['@id'].substring(1);
      if (postData == null) postData = ApiService.convertResourceToPostData(resource);
      
      this.eventService.apiLoading.emit({ loading: true, method: 'updateResource' });      
      this.restangular.all('').customPUT(postData, resourceUri, {}).subscribe(result => {
        this.eventService.apiLoading.emit({ loading: false });
        resolve(result);
      }, err => {
        this.eventService.apiLoading.emit({ loading: false });
        reject(err);
      });
    });
  }
  
  deleteResource(resource): Promise<boolean> {
    
    return new Promise((resolve, reject) => {
      
      let resourceUri = resource['@id'].substring(1);
      this.eventService.apiLoading.emit({ loading: true, method: 'deleteResource' });   
      this.restangular.all('').customDELETE(resourceUri).subscribe((deleted) => {
        this.eventService.apiLoading.emit({ loading: false });
        resolve(deleted);        
      }, err => {
        this.eventService.apiLoading.emit({ loading: false });
        reject(err);        
      });
      
    });
  }

  customDelete(resourceUri: string): Promise<boolean> {

    return new Promise((resolve, reject) => {
      
      this.eventService.apiLoading.emit({ loading: true, method: 'customDelete' });
      this.restangular.all('').customDELETE(resourceUri).subscribe((deleted) => {
        this.eventService.apiLoading.emit({ loading: false });
        resolve(deleted);
      }, err => {
        this.eventService.apiLoading.emit({ loading: false });
        reject(err);
      });

    });
  }


  uploadFile(file: File, type = null, endPoint = 'file/upload') {
    const formData = new FormData();
    formData.append('file', file);

    const params: any = {};
    if (type !== null) params.type = type;

    return this.customPost(endPoint, formData, params);    
  }
    
    
    
  private static convertResourceToPostData(resource): any {
    let postData = Object.assign({}, resource);
    for (let key in postData) {
      let value = postData[key];
      if (value !== null && typeof value === 'object' && value['@id']) {
        postData[key] = value['@id']
      }
      else if (value !== null && value instanceof Array) {
        postData[key] = ApiService.convertResourceToPostData(value);
      }
    }
    return postData;
  }
  
  resourceCustomPut(resourceIri: string, actionUri, data: any = null): any {
    return new Promise((resolve, reject) => {
      this.eventService.apiLoading.emit({ loading: true, method: 'resourceCustomPut' });

      this.restangular.one(resourceIri).customPUT(data, actionUri, {}).subscribe(result => {
        this.eventService.apiLoading.emit({ loading: false });
        resolve(result);
      }, err => {
        this.eventService.apiLoading.emit({ loading: false });
        reject(err);
      });
    });
  }
    
  customPost(endPoint: string, data: any = null, params: any = null): any {
    return new Promise((resolve, reject) => {
      this.eventService.apiLoading.emit({ loading: true, method: 'customPost' });

      this.restangular.all('').customPOST(data, endPoint, params).subscribe(result => {
        resolve(result);
      }, err => {
        reject(err);
      });
      
    });
  }
  
  customGet(endPoint: string, params: any = null): any {
    return new Promise((resolve, reject) => {
      this.eventService.apiLoading.emit({ loading: true, method: 'customGet' });
      this.restangular.all('').customGET(endPoint, params).subscribe(result => {
        resolve(result);
      }, err => {
        reject(err);
      });      
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/services/api.service.ts